// Guest keys are no longer stored in the browser.
// Public pages bootstrap an HttpOnly session via /public-pages/.../session/bootstrap.
const ScmMetaGuestKey = () => null;

export default ScmMetaGuestKey;
